import React from 'react';
import { FieldValues, Path } from 'react-hook-form';
import TextFieldWithControl from '~/App/shared/components/Fields/TextFieldWithControl';
import { TextFieldProps } from '../types';
import { fieldRuleFirstName } from '../fieldRules';

const FirstNameField = <FormState extends FieldValues>({
  control,
  t,
  name,
  rules,
  ...props
}: TextFieldProps<FormState>) => {
  const validationRules = {
    required: {
      value: true,
      message: t(`First name can't be blank`)
    },
    validate: fieldRuleFirstName(t),
    ...rules
  };

  const fieldName = name ?? ('firstName' as Path<FormState>);

  return (
    <TextFieldWithControl
      {...props}
      control={control}
      name={fieldName}
      autoComplete="given-name"
      label={t('First name')}
      rules={validationRules}
      required
    />
  );
};

export default FirstNameField;
